import { render, staticRenderFns } from "./remoteShareModal.vue?vue&type=template&id=b5e71208&scoped=true&"
import script from "./remoteShareModal.vue?vue&type=script&lang=js&"
export * from "./remoteShareModal.vue?vue&type=script&lang=js&"
import style0 from "./remoteShareModal.vue?vue&type=style&index=0&id=b5e71208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e71208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5e71208')) {
      api.createRecord('b5e71208', component.options)
    } else {
      api.reload('b5e71208', component.options)
    }
    module.hot.accept("./remoteShareModal.vue?vue&type=template&id=b5e71208&scoped=true&", function () {
      api.rerender('b5e71208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/management/components/remoteShareModal.vue"
export default component.exports